import { BUSINESS, PRODUCTS, SITE_URL } from "@/lib/constants";

const origin = () => SITE_URL;

export const organizationSchema = () => ({
  "@type": "Organization",
  "@id": `${origin()}/#organization`,
  name: BUSINESS.name,
  slogan: BUSINESS.tagline,
  url: `${origin()}/`,
  logo: `${origin()}/img/logo.webp`,
  email: BUSINESS.email,
  telephone: BUSINESS.phoneRaw,
  founder: { "@type": "Person", name: BUSINESS.proprietor },
  address: {
    "@type": "PostalAddress",
    streetAddress: BUSINESS.locality,
    addressLocality: BUSINESS.city,
    addressRegion: BUSINESS.region,
    postalCode: BUSINESS.postalCode,
    addressCountry: "IN",
  },
});

export const localBusinessSchema = () => ({
  "@context": "https://schema.org",
  "@graph": [
    organizationSchema(),
    {
      "@type": ["WholesaleStore", "LocalBusiness"],
      "@id": `${origin()}/#business`,
      name: BUSINESS.name,
      description:
        "Wholesale supplier of green cardamom, black pepper and selected whole spices to commercial buyers in Hyderabad and Telangana.",
      url: `${origin()}/`,
      image: `${origin()}/img/logo.webp`,
      telephone: BUSINESS.phoneRaw,
      email: BUSINESS.email,
      priceRange: "Quotation on enquiry",
      openingHours: "Mo-Sa 09:00-18:00",
      address: {
        "@type": "PostalAddress",
        streetAddress: BUSINESS.locality,
        addressLocality: BUSINESS.city,
        addressRegion: BUSINESS.region,
        postalCode: BUSINESS.postalCode,
        addressCountry: "IN",
      },
      areaServed: [
        { "@type": "City", name: "Hyderabad" },
        { "@type": "State", name: "Telangana" },
      ],
    },
  ],
});

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [{ name: "Home", url: `${origin()}/` }, ...items].map((item, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: item.name,
    item: item.url?.startsWith("http") ? item.url : `${origin()}${item.url || "/"}`,
  })),
});

// Product schema deliberately carries no price — rates are quoted per lot.
export const productListSchema = () => ({
  "@context": "https://schema.org",
  "@type": "ItemList",
  itemListElement: PRODUCTS.map((product, i) => ({
    "@type": "ListItem",
    position: i + 1,
    item: {
      "@type": "Product",
      name: product.name,
      description: product.description,
      image: product.image.url,
      category: "Whole spices — wholesale",
      brand: { "@type": "Brand", name: BUSINESS.name },
      offers: {
        "@type": "Offer",
        availability: "https://schema.org/LimitedAvailability",
        priceCurrency: "INR",
        priceSpecification: {
          "@type": "PriceSpecification",
          description: "Rate quoted on enquiry against the current lot.",
        },
        seller: { "@id": `${origin()}/#organization` },
      },
    },
  })),
});
